import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import settings from '../settings';
import Cookie from 'js-cookie'
import { AUTH_COOKIE_PATH } from '../constants.js'
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { loadMySuggestions } from '../actions';
import OrganizationList from '../components/OrganizationList';
import OrganizationsPagination from '../components/OrganizationsPagination';
import Swipeable from 'react-swipeable'


class SuggestionsList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      organizations: { results: [], isLoaded: true},
      hasError: false
    }
  }

  fetch(props, offset=0) {
    const { category, auth, browser } = props
    let token = Cookie.get(AUTH_COOKIE_PATH);
    const headers = { 'Authorization': `Token ${token}`}
    const limit = (browser.width < 750) ? 1 : 2
    if (category) {
      axios.get(`${settings.api.url}user/me/suggestions/`, {params: { limit, offset, category: category.childId }, headers })
      .then((response) => {
        this.setState({ organizations: { ...response.data, isLoaded: true }, hasError: false})
      })
      .catch((error) => {
        this.setState({ organizations: { results: [], isLoaded: false}, hasError: true})
      })
    }
  }

  previousPage = e => {
    e.preventDefault()
    const { previous, limit, offset } = this.state.organizations
    if(previous) {
      this.fetch(this.props, offset - limit);
    }
  }

  nextPage = e => {
    e.preventDefault();
    const { next, limit, offset} = this.state.organizations
    if(next) {
      this.fetch(this.props, offset + limit);
    }
  }

  pageJump = (number, e) => {
    const { count, limit, offset } = this.state.organizations;
    const maxOffset =  count - limit;
    let newOffset = number * limit - 2
    if(newOffset > maxOffset) {
      newOffset = maxOffset;
    }
    this.fetch(this.props, newOffset);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.category.path !== nextProps.category.path) {
      this.fetch(nextProps)
    }
  }
  componentDidMount() {
    this.fetch(this.props)
  }

  render() {
    const {auth, category} = this.props
    const { organizations, hasError } = this.state

    if (hasError) {
      return (
        <div className="profile-suggestionList ">
          <div><strong>{category.childName}</strong></div>
          <div className="alert alert-danger">Could not load suggestions.</div>
        </div>
      )
    }

    if (organizations.results && organizations.results.length == 0) {
      return (
        <div className="profile-suggestionList ">
          <div><strong>{category.rootName} &raquo; {category.childName}</strong> &nbsp;
          <img width="12" src="/images/ui/engineson.gif" /></div>
        </div>
      )
    }

    return (
      <div className="profile-suggestionsList">
        <table>
          <tbody>
            <tr>
              <td> <strong>{category.rootName} &raquo; {category.childName}</strong> </td>
              <td>
          <OrganizationsPagination organizations={organizations}
                                    pageJump={this.pageJump}
                                    nextPage={this.nextPage}
                                    previousPage={this.previousPage}
                                    nextLabel='&rarr;'
                                    prevLabel='&larr;' />
              </td>
            </tr>
          </tbody>
        </table>
        <Swipeable onSwipedRight={this.previousPage} onSwipedLeft={this.nextPage}>
        <OrganizationList user={auth.user} organizations={organizations} />
        </Swipeable>
      </div>
    )
  }

}


@connect(
  state => state,
  { push }
)
class ProfileSuggestions extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { auth } = this.props;
    if (!auth.isLoading && !auth.user) {
      this.props.push('/')
      return
    }
  }
  componentWillReceiveProps(nextProps) {
    const { auth } = nextProps;
    if (!auth.isLoading && !auth.user) {
      this.props.push('/')
      return
    }
  }

  render() {
    const { auth, browser } = this.props
    if (auth.isLoading) {
      return <span />
    }
    const { user: { interests }} = auth
    const cats = interests.categories_with_roots.map((category) => {
      return <SuggestionsList browser={browser} category={category} auth={auth} />
    })

    if (cats.length === 0 ) {
      return <div>
        <div class="alert">Tell us about your interests, so we can offer you resource suggestions.</div>
        <Link to="/my/interests" className="button button-primary">
        Add Interests
        </Link>
      </div>
    }
    return <span>{cats}</span>
  }
}



export default ProfileSuggestions



// WEBPACK FOOTER //
// ./src/containers/ProfileSuggestions.jsx